import { Megaphone, X } from "lucide-react";
import { useCanAccess } from "ra-core";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router";

import { useNow } from "../useNow";
import {
  BRIEF_SENT_EVENT,
  briefDue,
  briefSentToday,
  markBriefSent,
} from "./briefSent";
import { BRIEF_PATH } from "./dailyBrief";

/**
 * Admins, from 9:00 (Monday to Saturday): "El parte de hoy está listo",
 * until it is shared or dismissed on this device.
 */
export const BriefReminder = () => {
  const { canAccess: isAdmin = false } = useCanAccess({
    resource: "team",
    action: "list",
  });
  const now = useNow();
  const location = useLocation();
  const [sent, setSent] = useState(() => briefSentToday());

  useEffect(() => {
    setSent(briefSentToday(new Date(now)));
  }, [now]);
  useEffect(() => {
    const onSent = () => setSent(true);
    window.addEventListener(BRIEF_SENT_EVENT, onSent);
    return () => window.removeEventListener(BRIEF_SENT_EVENT, onSent);
  }, []);

  if (!isAdmin || sent || !briefDue(new Date(now))) return null;
  if (location.pathname === BRIEF_PATH) return null;

  return (
    <div className="mx-auto mt-2 flex max-w-screen-xl items-center gap-2 rounded-2xl bg-lime-200 px-3 py-2 text-sm text-neutral-900">
      <Megaphone className="h-4 w-4 shrink-0" />
      <span className="flex-1">
        El parte de hoy para los setters está listo.
      </span>
      <Link
        to={BRIEF_PATH}
        className="rounded-full bg-neutral-900 px-3 py-1 font-medium text-white"
      >
        Ver y compartir
      </Link>
      <button
        type="button"
        onClick={() => markBriefSent()}
        className="rounded-full p-1 hover:bg-white/60"
        title="Ya lo he mandado"
        aria-label="Ya lo he mandado"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
